/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import { useState } from 'react';
import PropTypes from 'prop-types';

import { useMediaQuery } from '@mantine/hooks';
import { breakpoints } from 'styles/theme.variables';

import { NumberInput } from '@mantine/core';
import { KEY_NAMES } from 'constants/global';

export default function EditablePrice({ disableEdit, handleEdit, price, rawPrice }) {
  const [isEditing, setIsEditing] = useState(false);
  const [currentValue, setCurrentValue] = useState('');

  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.lg})`);

  const handleSave = () => {
    if (currentValue !== rawPrice) {
      const formattedValue = Number(currentValue).toFixed(2);
      const numericValue = Math.round(parseFloat(formattedValue) * 100);
      handleEdit('price', numericValue);
    }
    setIsEditing(false);
  };

  const handleKeyDown = event => {
    if (event.key === KEY_NAMES.enter) {
      event.preventDefault();
      handleSave();
    }
  };

  const startEditing = () => {
    if (disableEdit) return;

    if (isDesktop) {
      setCurrentValue(rawPrice === '—' ? '' : rawPrice);
      setIsEditing(true);
    }
  };

  if (isEditing) {
    return (
      <NumberInput
        decimalScale={2}
        value={currentValue}
        onChange={setCurrentValue}
        onBlur={handleSave}
        onKeyDown={handleKeyDown}
        size="sm"
        autoFocus
        precision={2}
        allowNegative={false}
        rightSection={null}
        hideControls
        mb={0}
      />
    );
  }

  return (
    <div
      onClick={startEditing}
      style={{
        cursor: disableEdit ? 'not-allowed' : 'pointer',
      }}
    >
      {price}
    </div>
  );
}

EditablePrice.propTypes = {
  disableEdit: PropTypes.bool,
  handleEdit: PropTypes.func,
  rawPrice: PropTypes.string,
  price: PropTypes.node,
};
